import { types, flow } from "mobx-state-tree";
import { saveAs } from "file-saver";

import { URL_API } from "./globals";
import { Team } from "./common";

const RepostSalary = types
  .model("RepostSilpo", {
    date1: types.string,
    date2: types.string,
    currentTeam: types.optional(types.maybeNull(types.reference(Team)), null),
  })
  .actions((self) => ({
    setExcel: flow(function* () {
      const response = yield fetch(`${URL_API}/api/getexcelsalary`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            date1: self.date1,
            date2: self.date2,
            currentTeam: self.currentTeam?.uuid ?? null,
          },
        }),
      });
      const json = yield response.json();
      if (json.data.contents) {
        const base64 = json.data.contents;
        const file = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64}`;
        saveAs(file, "salary.xlsx");
      }
    }),
    setDate1: (date1) => (self.date1 = date1),
    setDate2: (date2) => (self.date2 = date2),
    setCurrentTeam: (cur) => (self.currentTeam = cur),
  }));

export default RepostSalary;
